import React from "react";
import { MattressTemplate } from "../../Templates/MattressTemplate";

export const Mattress = () => {
  return <MattressTemplate />;
};
